export const ALL_SHORTAGE_DATA = [
  {
    "_id": { "$oid": "69eb1ad9736df6a6aa14b217" },
    "ndc": "60951-602-70",
    "nda": "N/A",
    "brand_name": "N/A",
    "strength": "N/A",
    "route": "N/A",
    "dosage_forms": "N/A",
    "lms_flag": 0,
    "lms_entries": [
      {
        "source": "SP",
        "event_timestamp": "24-04-2026 12:55:13",
        "ndc": "60951-602-70",
        "nda_number": "N/A",
        "brand_name": "N/A",
        "section": "SHORTAGE",
        "whcich_filed": "NDA_MAPPING",
        "ip": "",
        "uniq_number": "865608053930",
        "new_data": [
          {
            "ndc": "60951-602-70",
            "nda": "N/A",
            "brand_name": "N/A",
            "strength": "N/A",
            "route": "N/A",
            "dosage_forms": "N/A",
            "excel_record": {
              "company_name": "Endo Pharmaceuticals, Inc.",
              "presentation": "Acetaminophen; Oxycodone Hydrochloride, Tablet, 325 mg; 5 mg (NDC 60951-602-70)",
              "type_of_update": "New",
              "availability_information": "N/A",
              "related_information": "Discontinuation of the manufacture of the drug",
              "resolved_note": "N/A",
              "reason_for_shortage": "N/A",
              "status": "To Be Discontinued",
              "change_date": null,
              "change_date_obj": null,
              "date_of_update": "11/03/2025",
              "date_of_update_obj": { "$date": "2025-11-03T00:00:00.000Z" },
              "date_discontinued": "11/03/2025",
              "date_discontinued_obj": { "$date": "2025-11-03T00:00:00.000Z" },
              "initial_posting_date": "11/03/2025",
              "initial_posting_date_obj": { "$date": "2025-11-03T00:00:00.000Z" },
              "therapeutic_category": "Analgesia/Addiction"
            }
          }
        ],
        "lms_flag": 0,
        "approved_time_stamp": "",
        "rejected_time_stamp": "",
        "approved_or_rejected_bool": false,
        "approved_rejected_by": "",
        "review_time_stamp": "",
        "website": "website0"
      }
    ],
    "created_at": { "$date": "2026-04-24T07:25:13.029Z" },
    "therapeutic_category": "Analgesia/Addiction"
  },
  {
    "_id": { "$oid": "69eb1ad9736df6a6aa14b233" },
    "ndc": "0487-9901-30",
    "nda": "019269",
    "brand_name": "VENTOLIN",
    "strength": "EQ 0.5% BASE",
    "route": "INHALATION",
    "dosage_forms": "LIQUID",
    "lms_flag": 4,
    "lms_entries": [
      {
        "source": "SP",
        "event_timestamp": "24-04-2026 12:55:13",
        "ndc": "0487-9901-30",
        "nda_number": "019269",
        "brand_name": "VENTOLIN",
        "section": "SHORTAGE",
        "whcich_filed": "NDA_MAPPING",
        "ip": "",
        "uniq_number": "430650187812",
        "new_data": [
          {
            "ndc": "0487-9901-30",
            "nda": "019269",
            "brand_name": "VENTOLIN",
            "strength": "EQ 0.5% BASE",
            "route": "INHALATION",
            "dosage_forms": "LIQUID",
            "excel_record": {
              "company_name": "Nephron Pharmaceuticals Corporation",
              "presentation": "Albuterol Sulfate, Solution, 2.5 mg/.5 mL (NDC 0487-9901-30)",
              "type_of_update": "Reverified",
              "availability_information": "Available",
              "related_information": "Albuterol 0.5% is in stock, though demand remains high; additional supply can be produced as needed.",
              "resolved_note": "N/A",
              "reason_for_shortage": "N/A",
              "status": "Current",
              "change_date": null,
              "change_date_obj": null,
              "date_of_update": "04/20/2026",
              "date_of_update_obj": { "$date": "2026-04-20T00:00:00.000Z" },
              "date_discontinued": null,
              "date_discontinued_obj": null,
              "initial_posting_date": "10/25/2022",
              "initial_posting_date_obj": { "$date": "2022-10-25T00:00:00.000Z" },
              "therapeutic_category": "Pulmonary/Allergy; Pediatric"
            }
          }
        ],
        "lms_flag": 4,
        "approved_time_stamp": "",
        "rejected_time_stamp": "",
        "approved_or_rejected_bool": false,
        "approved_rejected_by": "",
        "review_time_stamp": "",
        "website": "website0"
      }
    ],
    "created_at": { "$date": "2026-04-24T07:25:13.380Z" },
    "therapeutic_category": "Pulmonary/Allergy; Pediatric"
  },
  {
    "_id": { "$oid": "69eb1ad9736df6a6aa14b239" },
    "ndc": "0591-5543-01",
    "nda": "018832",
    "brand_name": "ALLOPURINOL",
    "strength": "100MG",
    "route": "ORAL",
    "dosage_forms": "TABLET",
    "lms_flag": 1,
    "lms_entries": [
      {
        "source": "SP",
        "event_timestamp": "24-04-2026 12:55:13",
        "ndc": "0591-5543-01",
        "nda_number": "018832",
        "brand_name": "ALLOPURINOL",
        "section": "SHORTAGE",
        "whcich_filed": "NDA_MAPPING",
        "ip": "",
        "uniq_number": "536844505199",
        "new_data": [
          {
            "ndc": "0591-5543-01",
            "nda": "018832",
            "brand_name": "ALLOPURINOL",
            "strength": "100MG",
            "route": "ORAL",
            "dosage_forms": "TABLET",
            "excel_record": {
              "company_name": "Teva Pharmaceuticals USA, Inc.",
              "presentation": "Allopurinol, Tablet, 100 mg (NDC 0591-5543-01)",
              "type_of_update": "New",
              "availability_information": "N/A",
              "related_information": "Discontinuation of the manufacture of the drug",
              "resolved_note": "N/A",
              "reason_for_shortage": "N/A",
              "status": "To Be Discontinued",
              "change_date": null,
              "change_date_obj": null,
              "date_of_update": "02/19/2026",
              "date_of_update_obj": { "$date": "2026-02-19T00:00:00.000Z" },
              "date_discontinued": "02/19/2026",
              "date_discontinued_obj": { "$date": "2026-02-19T00:00:00.000Z" },
              "initial_posting_date": "02/19/2026",
              "initial_posting_date_obj": { "$date": "2026-02-19T00:00:00.000Z" },
              "therapeutic_category": "Oncology; Renal; Rheumatology"
            }
          }
        ],
        "lms_flag": 1,
        "approved_time_stamp": "",
        "rejected_time_stamp": "",
        "approved_or_rejected_bool": false,
        "approved_rejected_by": "",
        "review_time_stamp": "",
        "website": "website0"
      }
    ],
    "created_at": { "$date": "2026-04-24T07:25:13.401Z" },
    "therapeutic_category": "Oncology; Renal; Rheumatology"
  },
  {
    "_id": { "$oid": "69eb1ad9736df6a6aa14b25b" },
    "ndc": "0338-0644-04",
    "nda": "018931",
    "brand_name": "TRAVASOL 10%",
    "strength": "10%",
    "route": "INJECTION",
    "dosage_forms": "LIQUID",
    "lms_flag": 1,
    "lms_entries": [
      {
        "source": "SP",
        "event_timestamp": "24-04-2026 12:55:13",
        "ndc": "0338-0644-04",
        "nda_number": "018931",
        "brand_name": "TRAVASOL 10%",
        "section": "SHORTAGE",
        "whcich_filed": "NDA_MAPPING",
        "ip": "",
        "uniq_number": "345320851523",
        "new_data": [
          {
            "ndc": "0338-0644-04",
            "nda": "018931",
            "brand_name": "TRAVASOL 10%",
            "strength": "10%",
            "route": "INJECTION",
            "dosage_forms": "LIQUID",
            "excel_record": {
              "company_name": "Baxter Healthcare",
              "presentation": "Travasol, Injection, 2.07 g/100 mL (NDC 0338-0644-04)",
              "type_of_update": "Reverified",
              "availability_information": "Unavailable",
              "related_information": "Estimated recovery: mid April 2026",
              "resolved_note": "N/A",
              "reason_for_shortage": "Demand increase for the drug",
              "status": "Current",
              "change_date": null,
              "change_date_obj": null,
              "date_of_update": "04/20/2026",
              "date_of_update_obj": { "$date": "2026-04-20T00:00:00.000Z" },
              "date_discontinued": null,
              "date_discontinued_obj": null,
              "initial_posting_date": "04/10/2026",
              "initial_posting_date_obj": { "$date": "2026-04-10T00:00:00.000Z" },
              "therapeutic_category": "Gastroenterology"
            }
          }
        ],
        "lms_flag": 1,
        "approved_time_stamp": "",
        "rejected_time_stamp": "",
        "approved_or_rejected_bool": false,
        "approved_rejected_by": "",
        "review_time_stamp": "",
        "website": "website0"
      }
    ],
    "created_at": { "$date": "2026-04-24T07:25:13.507Z" },
    "therapeutic_category": "Gastroenterology"
  }
];
